// Entry point. Fetches the session context, publishes it as the window.*
// globals the application reads, then loads the application. Every way of
// serving the page starts here — the nginx container, meteo-server itself, the
// --debug run — so there is one startup and one place the names are mapped.
//
// The load MUST be a dynamic import and this file MUST NOT statically import
// anything from the application. Several modules capture the globals at import
// time (PermissionHelper.js, NiraApi.js, the Redux initial state in
// server.default.js), and static imports are hoisted ahead of every statement
// here — so a static import would evaluate them before the fetch has run and
// they would all see undefined.
async function loadContext() {
    const response = await fetch("/public-api/app-context/", { credentials: "same-origin" });
    if (!response.ok) {
        throw new Error(`app-context ${response.status}`);
    }
    const ctx = await response.json();

    window.NiraDriverUrl = ctx.nira_driver_url;
    window.NiraArchiveUrl = ctx.nira_archive_url;
    window.SystemReadOnly = ctx.system_read_only === true;
    window.BuildInfo = ctx.build_info;
    window.BuildCommitSubject = ctx.build_commit_subject;
    // both left undefined when logged out — security.js reads that as "no user"
    if (ctx.access) {
        window.AppAccess = ctx.access;
    }
    if (ctx.user) {
        window.MeteoCtx = { user: ctx.user };
    }
}

loadContext()
    .then(() => import("./index.js"))
    .catch((e) => {
        console.error("unable to start the application", e);
        document.getElementById("root").textContent = "Application failed to start. Reload the page.";
    });
